import React from 'react'
import Notes from '../Notes'
import { Container } from 'react-bootstrap'

function Valiadtion1() {
  return (
    <>
        {/* <Notes user={user} path={path} /> */}
        
        <Container fluid className='px-5 mt-4'>
            <p className='fs-5 text-uppercase text-decoration-underline' style={{fontWeight : '500', color : "red"}}>Random 10 Number Generation Code</p>

            <p className='mb-1'><b>replaceAll(generateSystemNodeRandomNumber(tools,@String.length(pxProcess.pxSystemNodeID)+10),pxProcess.pxSystemNodeID,"")</b></p>
            
     
      

        </Container>
    </>
  )
}

export default Valiadtion1